import React from 'react';
import { Skeleton, Avatar, Upload } from 'antd';
import { CameraOutlined, LoadingOutlined } from '@ant-design/icons';
import Wrapper from './style';
import { getNickName } from '../../utils/commonUtils';

const Index = (props) => {
  const {
    isLoading,
    name,
    urlLink,
    isLoadingUploadImage,
    customRequest,
    isDisableUpload = false,
  } = props;

  return (
    <Wrapper>
      <div className="component_account_photo ">
        {isLoading && <Skeleton.Avatar active size={172} />}
        {!isLoading && (
          <div className="component_account_photo_img">
            {isLoadingUploadImage && (
              <LoadingOutlined className="component_loading_upload" />
            )}
            {urlLink && <Avatar src={urlLink} alt="toko" />}
            {!urlLink && (
              <Avatar className="component_account_card_text">
                {name?.length > 0 && getNickName(name)}
              </Avatar>
            )}
            {!isDisableUpload && (
              <div className="component_account_upload_button">
                <Upload
                  showUploadList={false}
                  accept=".png,.jpg,.jpeg"
                  customRequest={customRequest}
                  // progress={isLoadingUploadImage}
                  // onChange={onChangeInput}
                >
                  <CameraOutlined />
                </Upload>
              </div>
            )}
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default Index;
